import React, { useEffect } from "react";
import Modal from "react-modal";
import { useRecoilState } from "recoil";
import styled from "styled-components";
import LogController from "../../controller/LogController";
import { langState, langText } from "../../recoil/lang";
import "../../styles/CustomModal.css";

const ArrivalModal = (oProps: {
  isVisible: boolean;
  setVisible: any;
  pickup_name: string;
  pickup_name_en: string;
}) => {
  const [lang, setLang] = useRecoilState<number>(langState);

  const onCloseModal = () => {
    oProps.setVisible(false);
    LogController.click({
      path: "ArrivalModal",
      params: "arrival",
      params2: "사용자가 주문도착 모달 닫음",
    });
  };

  useEffect(() => {
    if (oProps.isVisible) {
      LogController.event({
        path: "ArrivalModal",
        params: "arrival",
        params2: "주문도착 모달 열림",
      });
    }
  }, [oProps.isVisible]);

  return (
    <Modal
      isOpen={oProps.isVisible}
      onRequestClose={onCloseModal}
      className="arrivalModal modal-content"
      closeTimeoutMS={100}
      shouldCloseOnOverlayClick={false}
      ariaHideApp={false}
    >
      <Style>
        <div className="modal">
          <img
            src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_location.svg`}
            alt="ic"
          />
          <p className="titleFont">{langText.arrivalModal_title[lang]}</p>
          <img
            className="closeIcon"
            onClick={onCloseModal}
            src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close_black.svg`}
            alt="ic"
          />
          <div>
            <h1>{lang === 0 ? oProps.pickup_name : oProps.pickup_name_en}</h1>
          </div>
          <div className="confirmButton" onClick={onCloseModal}>
            {langText.button_confirm[lang]}
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default ArrivalModal;

const Style = styled.div`
  img {
    padding-bottom: 6px;
  }
  .modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    position: relative;
    gap: 16px;
    padding: 8%;
    width: 100%;
    height: 100%;
  }
  .titleFont {
    font-size: 20px;
    line-height: 32px;
    font-weight: 400;
    color: #000000;
    text-align: center;
    margin: 0 0;
  }
  .closeIcon {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 40px;
  }

  h1 {
    text-align: center;
    line-height: 48px;
    color: #40977f;
    font-weight: 600;
  }
  .confirmButton {
    width: 90%;
    padding: 16px;
    background: #4dd2ae;
    font-size: 24px;
    line-height: 32px;
    border-radius: 10px;
    color: #ffffff;
    font-weight: 600;
    text-align: center;
  }

  @media (max-width: 700px) {
    img {
      width: 40px;
      padding-bottom: 0;
    }
    .closeIcon {
      width: 24px;
      right: 12px;
      top: 12px;
    }
    .modal {
      gap: 10px;
    }
    .titleFont {
      font-size: 16px;
      line-height: 24px;
      font-weight: 500;
    }

    h1 {
      font-size: 20px;
      line-height: 32px;
      font-weight: 700;
    }
    .confirmButton {
      width: 100%;
      padding: 10px;
      font-size: 20px;
      border-radius: 10px;
    }
  }
`;
